import { api } from "./http-client";

interface SystemStatus {
  maintenance: boolean;
}

export const systemService = {
  getStatus: async (): Promise<SystemStatus> => {
    const response = await api.request<SystemStatus>({
      url: "/system/status",
      method: "GET",
      skipErrorDialog: true,
    });
    return response.data;
  },

  toggleMaintenance: async (enabled: boolean): Promise<{ maintenance: boolean }> => {
    const response = await api.request<{ maintenance: boolean }>({
      url: "/system/maintenance",
      method: "POST",
      data: { enabled },
    });
    return response.data;
  },
};
